// automatically generated by the FlatBuffers compiler, do not modify

export enum DateUnit {
  DAY = 0,
  MILLISECOND = 1
}
